module.exports = __webpack_public_path__ + "img/hxsd_img2.2cbb899d.png";